const translations = {
    title: {
        homePage: 'Template de Plugins',
        exemples: 'Exemplos',
        systemInfo: 'Informações do sistema',
        userInfo: 'Informações do usuário'
    },
    paragraph: {
        homeDescription: {
            part1: 'Este é um modelo de plugin básico',
            part2: 'Edite <1>src/pages/Home.js</1> e salve para recarregar.'
        }
    },
    link: {
        blipDataExample: 'Obtenha dados do blip',
        swrExemple: 'Buscar dados com SWR'
    },
    button: {
        repository: 'Visite o Repositório'
    },
    menu: {
        goBack: 'Voltar'
    },
    name: 'Nome',
    shortName: 'Nome abreviado',
    email: 'E-mail',
    phone: 'Telefone',
    identity: 'Identificador',
    identifier: 'Identificador',
    language: 'Idioma',
    accessKey: 'Chave de acesso',
    template: 'Template',
    creationDate: 'Data de criação'
};

export default translations;
